export default "__VITE_ASSET__4ce45ecb__"